<ul class="nav nav-toolbar autorisatie-menu">
    <li class="autorisatie-menu__item autorisatie-menu__item--desktop" *ngIf="(authenticated$ | async) === false">
        <a title="Schademelden" [href]="baseUrl + appRoutesEnum.OldClaimFunnel" ins-authorize-before-redirect>
            Schademelden
        </a>
    </li>
    <li
        class="polismap-menu autorisatie-menu__item autorisatie-menu__item--desktop"
        *ngIf="relation$ | async as relation"
    >
        <div insDropdown [options]="{ align: 'right' }" #autorisatiemenu="dropdown">
            <button
                insDropdownToggle
                (click)="autorisatiemenu.toggle()"
                class="polismap-menu-button polismap-menu-button--user"
                e2e="autorisation_menu_link"
                title="Mijn Verzekeringsmap"
            >
                <span class="btn-label-arrow">
                    <svg class="svg-icon svg-icon--l">
                        <use [attr.href]="baseUrl + '/assets/icons-general.svg#pijlRR'"></use>
                    </svg>
                    Mijn Verzekeringsmap
                </span>
                <svg class="icon-user svg-icon svg-icon--xs svg-icon--dark">
                    <use [attr.href]="baseUrl + '/assets/icons-ui.svg#gebruiker'"></use>
                </svg>
                <span class="name" data-hj-suppress e2e="user_fullname" *ngIf="relation?.name">
                    {{ relation?.name }}
                </span>
                <svg class="icon-down svg-icon svg-icon--xs svg-icon--dark">
                    <use [attr.href]="baseUrl + '/assets/icons-ui.svg#onder-closed'"></use>
                </svg>
            </button>
            <ul insDropdownMenu class="dropdown-menu polismap-menu__dropdown cs-schadevrije-jaren">
                <li class="polismap-menu__item">
                    <a title="Mijn verzekeringen" href="{{ baseUrl }}/verzekeringsmap/mijn-verzekeringen">
                        Mijn verzekeringen
                    </a>
                </li>
                <li class="polismap-menu__item">
                    <a
                        title="Schademelden"
                        [href]="baseUrl + appRoutesEnum.OldClaimFunnel"
                        ins-authorize-before-redirect
                    >
                        Schademelden
                    </a>
                </li>
                <li class="polismap-menu__item">
                    <a title="Schadestatus" href="{{ baseUrl }}/verzekeringsmap/mijn-schades">Schadestatus</a>
                </li>
                <li class="polismap-menu__item">
                    <a title="Mijn gegevens" href="{{ baseUrl }}/verzekeringsmap/mijn-gegevens">Mijn gegevens</a>
                </li>
                <li class="polismap-menu__item">
                    <a title="Facturen" href="{{ baseUrl }}/verzekeringsmap/mijn-facturen">Facturen</a>
                </li>
                <li class="cs-persoonlijke-jaarbeloning polismap-menu__item">
                    <a title="JaarBalans" href="{{ baseUrl }}/verzekeringsmap/jaarbalans">
                        <span>JaarBalans</span>
                    </a>
                </li>
                <li class="polismap-menu__item">
                    <a title="Uitloggen" href="#" (click)="onSignOut($event)" e2e="logout">Uitloggen</a>
                </li>
            </ul>
        </div>
    </li>

    <li class="autorisatie-menu__item" *ngIf="(authenticated$ | async) === false">
        <button
            (click)="gotoLogin()"
            id="gebruikerMenu"
            class="polismap-menu-button"
            e2e="user-menu-login"
            title="Inloggen"
        >
            <svg class="icon-user svg-icon svg-icon--xs svg-icon--dark">
                <use [attr.href]="baseUrl + '/assets/icons-ui.svg#gebruiker'"></use>
            </svg>
            <span class="autorisatie-menu__login-text">Inloggen</span>
        </button>
    </li>
    <li *ngIf="relation$ | async as relation" class="autorisatie-menu__item--mobile">
        <a
            id="account-menu-button"
            (click)="$event.preventDefault(); accountMenu.open({ status: true, userName: relation.name })"
            title="Account menu"
            href="#"
            aria-controls="account-menu"
            aria-expanded="false"
        >
            <span class="screen-reader-only">Account menu</span>
            <wuc-icon-ui type="primary" size="m" icon="user-checked"></wuc-icon-ui>
        </a>
    </li>
    <li class="autorisatie-menu__contact autorisatie-menu__item--mobile">
        <a
            class="contact-menu-link"
            title="Stel uw vraag"
            href="{{ baseUrl }}/contact"
            e2e="menu-contact"
            (mouseenter)="isContactHoverState = true"
            (mouseleave)="isContactHoverState = false"
        >
            <wuc-icon-ui
                class="contact-menu-icon"
                icon="chat"
                [type]="isContactHoverState ? 'primary' : 'dark'"
                size="s"
            />
            <span class="autorisatie-menu__contact-text">Stel uw vraag</span>
        </a>
    </li>

    <li class="autorisatie-menu__contact autorisatie-menu__item--desktop">
        <a
            class="contact-menu-link"
            title="Stel uw vraag"
            href="{{ baseUrl }}/contact"
            e2e="menu-contact"
            (mouseenter)="isContactHoverState = true"
            (mouseleave)="isContactHoverState = false"
        >
            <wuc-icon-ui
                class="contact-menu-icon"
                icon="chat"
                [type]="isContactHoverState ? 'primary' : 'dark'"
                size="s"
            />
            <span class="autorisatie-menu__contact-text">Stel uw vraag</span>
        </a>
    </li>
    <li class="autorisatie-menu__item--mobile">
        <a
            id="mobile-menu-button"
            (click)="$event.preventDefault(); mobileMenu.open({ status: false })"
            title="Menu"
            href="#"
            aria-controls="mobile-menu"
            aria-expanded="false"
        >
            <wuc-icon-ui
                [type]="(authenticated$ | async) === true ? 'dark' : 'primary'"
                size="m"
                icon="navigation"
            ></wuc-icon-ui>
            <span class="screen-reader-only">Menu</span>
        </a>
    </li>
</ul>
<web-mobile-menu
    #mobileMenu
    back-button-aria-label="Ga terug"
    close-button-aria-label="Sluiten"
    menu-type="mobileMenu"
    (webMobileMenuNavigate)="onMobileMenuClick($event)"
>
    <div
        class="sc-web-mobile-menu"
        *ngIf="isServerPlatform"
        id="mobile-menu"
        aria-label="Menu"
        aria-labelledby="mobile-menu-button"
    >
        <dialog class="sc-web-mobile-menu">
            <header part="header">
                <button aria-label="Ga terug">
                    <span>
                        <web-link icon-start="chevron-left">
                            <a class="link link-secondary" href="#" target="_self">
                                <span class="screen-reader-only">Ga terug</span>
                            </a>
                        </web-link>
                    </span>
                </button>
                <div part="menu-title" class="sc-web-mobile-menu">Menu</div>
                <button aria-label="Sluiten">
                    <span class="close-button">
                        <web-link icon-end="close-thin">
                            <a class="link link-primary" href="#" target="_self">Sluiten</a>
                        </web-link>
                    </span>
                </button>
            </header>
            <hr part="divider" class="sc-web-mobile-menu" />
            <main class="sc-web-mobile-menu">
                <nav
                    id="menu-hoofdmenu"
                    data-menu-name="menu-hoofdmenu"
                    title="Hoofdmenu"
                    aria-label="Hoofdmenu"
                    inert=""
                >
                    <web-list class="sc-web-mobile-menu hydrated">
                        <ul style="grid-template-rows: repeat(5, auto)">
                            <li>
                                <a
                                    id="menu-onze-verzekeringen-trigger"
                                    role="menuitem"
                                    class="simple"
                                    href="#"
                                    title="Onze verzekeringen"
                                    aria-label="Onze verzekeringen"
                                    aria-haspopup="true"
                                    aria-controls="menu-onze-verzekeringen"
                                    data-menu-link="menu-onze-verzekeringen"
                                >
                                    Onze verzekeringen
                                    <web-icon class="icon-end hydrated">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/chevron-right.svg#chevron-right"></use>
                                        </svg>
                                    </web-icon>
                                </a>
                            </li>
                            <li>
                                <a
                                    id="menu-service-and-schade-trigger"
                                    role="menuitem"
                                    class="simple"
                                    href="#"
                                    title="Service &amp; Schade"
                                    aria-label="Service &amp; Schade"
                                    aria-haspopup="true"
                                    aria-controls="menu-service-and-schade"
                                    data-menu-link="menu-service-and-schade"
                                >
                                    Service &amp; Schade
                                    <web-icon class="icon-end hydrated">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/chevron-right.svg#chevron-right"></use>
                                        </svg>
                                    </web-icon>
                                </a>
                            </li>
                            <li>
                                <a
                                    id="menu-over-inshared-trigger"
                                    role="menuitem"
                                    class="simple"
                                    href="#"
                                    title="Over InShared"
                                    aria-label="Over InShared"
                                    aria-haspopup="true"
                                    aria-controls="menu-over-inshared"
                                    data-menu-link="menu-over-inshared"
                                >
                                    Over InShared
                                    <web-icon class="icon-end hydrated">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/chevron-right.svg#chevron-right"></use>
                                        </svg>
                                    </web-icon>
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/slimme-tips"
                                    title="Slimme Tips"
                                    aria-label="Slimme Tips"
                                    rel=""
                                    role="menuitem"
                                >
                                    Slimme Tips
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/faq"
                                    title="Veelgestelde vragen"
                                    aria-label="Veelgestelde vragen"
                                    rel=""
                                    role="menuitem"
                                >
                                    Veelgestelde vragen
                                </a>
                            </li>
                        </ul>
                    </web-list>
                    <hr />
                    <web-list class="sc-web-mobile-menu">
                        <ul style="grid-template-rows: repeat(1, auto)">
                            <li>
                                <a
                                    class="simple"
                                    href="/contact"
                                    title="Contact"
                                    aria-label="Contact"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/chat.svg#chat"></use>
                                        </svg>
                                    </web-icon>
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </web-list>
                </nav>
                <nav
                    id="menu-onze-verzekeringen"
                    data-menu-name="menu-onze-verzekeringen"
                    title="Onze verzekeringen"
                    aria-labelledby="menu-onze-verzekeringen-trigger"
                    inert=""
                >
                    <web-list class="sc-web-mobile-menu">
                        <ul style="grid-template-rows: repeat(14, auto)">
                            <li>
                                <a
                                    class="simple"
                                    href="/autoverzekering"
                                    title="Autoverzekering"
                                    aria-label="Autoverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/car.svg#car"></use>
                                        </svg>
                                    </web-icon>
                                    Autoverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/reisverzekering"
                                    title="Reisverzekering"
                                    aria-label="Reisverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/travel.svg#travel"></use>
                                        </svg>
                                    </web-icon>
                                    Reisverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/woonverzekering"
                                    title="Woonverzekering"
                                    aria-label="Woonverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/house.svg#house"></use>
                                        </svg>
                                    </web-icon>
                                    Woonverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/opstalverzekering"
                                    title="Opstalverzekering"
                                    aria-label="Opstalverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/house.svg#house"></use>
                                        </svg>
                                    </web-icon>
                                    Opstalverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/inboedelverzekering"
                                    title="Inboedelverzekering"
                                    aria-label="Inboedelverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/contents.svg#contents"></use>
                                        </svg>
                                    </web-icon>
                                    Inboedelverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/dierenverzekering"
                                    title="Dierenverzekering"
                                    aria-label="Dierenverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/pet.svg#pet"></use>
                                        </svg>
                                    </web-icon>
                                    Dierenverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/fietsverzekering"
                                    title="Fietsverzekering"
                                    aria-label="Fietsverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/bicycle.svg#bicycle"></use>
                                        </svg>
                                    </web-icon>
                                    Fietsverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/brommerverzekering"
                                    title="Brommerverzekering"
                                    aria-label="Brommerverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/moped.svg#moped"></use>
                                        </svg>
                                    </web-icon>
                                    Brommerverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/scooterverzekering"
                                    title="Scooterverzekering"
                                    aria-label="Scooterverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/scooter.svg#scooter"></use>
                                        </svg>
                                    </web-icon>
                                    Scooterverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/motorverzekering"
                                    title="Motorverzekering"
                                    aria-label="Motorverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/motorcycle.svg#motorcycle"></use>
                                        </svg>
                                    </web-icon>
                                    Motorverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/caravanverzekering"
                                    title="Caravanverzekering"
                                    aria-label="Caravanverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/caravan.svg#caravan"></use>
                                        </svg>
                                    </web-icon>
                                    Caravanverzekering
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/rechtsbijstandverzekering"
                                    title="Rechtsbijstand"
                                    aria-label="Rechtsbijstand"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/legal.svg#legal"></use>
                                        </svg>
                                    </web-icon>
                                    Rechtsbijstand
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/aansprakelijkheidsverzekering"
                                    title="Aansprakelijkheid"
                                    aria-label="Aansprakelijkheid"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/liability.svg#liability"></use>
                                        </svg>
                                    </web-icon>
                                    Aansprakelijkheid
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/ongevallenverzekering"
                                    title="Ongevallenverzekering"
                                    aria-label="Ongevallenverzekering"
                                    rel=""
                                    role="menuitem"
                                >
                                    <web-icon class="icon-start">
                                        <svg fill="currentColor" role="img" focusable="false">
                                            <use href="/assets/icons/ui/accident.svg#accident"></use>
                                        </svg>
                                    </web-icon>
                                    Ongevallenverzekering
                                </a>
                            </li>
                        </ul>
                    </web-list>
                </nav>
                <nav
                    id="menu-service-and-schade"
                    data-menu-name="menu-service-and-schade"
                    title="Service &amp; Schade"
                    aria-labelledby="menu-service-and-schade-trigger"
                    inert=""
                >
                    <div class="grid-item" role="menuitem">
                        <div class="h4 item-heading">Nood of pech onderweg</div>
                        <p>Bij noodsituaties, zoals diefstal van auto, woninginbraak, letsel of grote lekkage bel</p>
                        <web-link text="+31 (0)71 364 17 62" title="+31 (0)71 364 17 62">
                            <a
                                class="link"
                                href="tel:+31713641762"
                                title="+31 (0)71 364 17 62"
                                aria-label="+31 (0)71 364 17 62"
                                rel=""
                                target="_self"
                            >
                                <web-icon class="icon-start">
                                    <svg fill="currentColor" role="img" focusable="false">
                                        <use href="/assets/icons/ui/phone.svg#phone"></use>
                                    </svg>
                                </web-icon>
                                <span>+31 (0)71 364 17 62</span>
                            </a>
                        </web-link>
                    </div>
                    <div class="grid-item" role="menuitem">
                        <div class="h4 item-heading">Geen nood</div>
                        <p>Schade, declaratie huisdier, juridisch conflict of reismelding?</p>
                        <web-button
                            text="Meld schade online"
                            url="/verzekeringsmap/mijn-schades"
                            kind="primary"
                            alt="Naar verzekeringsmap"
                        >
                            <button
                                class="button button-secondary button-large button-full-width"
                                title="Meld schade online"
                            >
                                <web-icon class="icon-start">
                                    <svg fill="currentColor" role="img" focusable="false">
                                        <use
                                            href="/assets/icons/ui/emergency-simplified.svg#emergency-simplified"
                                        ></use>
                                    </svg>
                                </web-icon>
                                Meld schade online
                            </button>
                        </web-button>
                    </div>
                    <hr />
                    <div class="grid-item sc-web-mobile-menu" role="menuitem">
                        <div class="h4 item-heading sc-web-mobile-menu">Alles over schade</div>
                        <p>Bij noodsituaties, zoals diefstal van auto, woninginbraak, letsel of grote lekkage</p>
                        <web-list>
                            <ul style="grid-template-rows: repeat(2, auto)">
                                <li>
                                    <a
                                        class="simple"
                                        href="/schade"
                                        title="Help, ik heb schade!"
                                        aria-label="Help, ik heb schade!"
                                        role="menuitem"
                                    >
                                        <web-icon class="icon-start">
                                            <svg fill="currentColor" role="img" focusable="false">
                                                <use href="/assets/icons/ui/chevron-right.svg#chevron-right"></use>
                                            </svg>
                                        </web-icon>
                                        Help, ik heb schade!
                                    </a>
                                </li>
                                <li>
                                    <a
                                        class="simple"
                                        href="/jaarbalans/jaarbalans-2024"
                                        title="Schadeverslag"
                                        aria-label="Schadeverslag"
                                        role="menuitem"
                                    >
                                        <web-icon class="icon-start hydrated">
                                            <svg fill="currentColor" role="img" focusable="false">
                                                <use href="/assets/icons/ui/chevron-right.svg#chevron-right"></use>
                                            </svg>
                                        </web-icon>
                                        Schadeverslag
                                    </a>
                                </li>
                            </ul>
                        </web-list>
                    </div>
                    <div class="grid-item" role="menuitem">
                        <div class="h4 item-heading">Al schade gemeld?</div>
                        <p>Bekijk hier de status van uw lopende schade</p>
                        <web-button
                            text="Bekijk schade status"
                            url="/verzekeringsmap/mijn-schades"
                            kind="primary"
                            alt="Bekijk schade status"
                        >
                            <button
                                class="button button-secondary button-large button-full-width"
                                title="Bekijk schade status"
                            >
                                <web-icon class="icon-start hydrated">
                                    <svg fill="currentColor" role="img" focusable="false">
                                        <use href="/assets/icons/ui/view-damage.svg#view-damage"></use>
                                    </svg>
                                </web-icon>
                                Bekijk schade status
                            </button>
                        </web-button>
                    </div>
                </nav>
                <nav
                    id="menu-over-inshared"
                    data-menu-name="menu-over-inshared"
                    title="Over InShared"
                    aria-labelledby="menu-over-inshared-trigger"
                    inert=""
                >
                    <web-list>
                        <ul style="grid-template-rows: repeat(8, auto)">
                            <li>
                                <a
                                    class="simple"
                                    [href]="baseUrl + '/' + appRoutesEnum.OurBenefits"
                                    title="Onze benefits"
                                    aria-label="Onze benefits"
                                    rel=""
                                    role="menuitem"
                                >
                                    Onze benefits
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/over-inshared/alles-online"
                                    title="Het gemak van alles online"
                                    aria-label="Het gemak van alles online"
                                    rel=""
                                    role="menuitem"
                                >
                                    Het gemak van alles online
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/hoe-tevreden-zijn-klanten"
                                    title="Hoe tevreden zijn klanten"
                                    aria-label="Hoe tevreden zijn klanten"
                                    rel=""
                                    role="menuitem"
                                >
                                    Hoe tevreden zijn klanten
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/over-inshared#klachten"
                                    title="Niet tevreden?"
                                    aria-label="Niet tevreden?"
                                    rel=""
                                    role="menuitem"
                                >
                                    Niet tevreden?
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="/contact/reviews"
                                    title="Reviews"
                                    aria-label="Reviews"
                                    rel=""
                                    role="menuitem"
                                >
                                    Reviews
                                </a>
                            </li>
                            <li>
                                <a
                                    class="simple"
                                    href="https://jobsinshared.com"
                                    title="Werken bij"
                                    aria-label="Werken bij"
                                    rel="noopener noindex nofollow"
                                    role="menuitem"
                                >
                                    Werken bij
                                </a>
                            </li>
                        </ul>
                    </web-list>
                </nav>
            </main>
        </dialog>
    </div>
</web-mobile-menu>
<web-mobile-menu
    #accountMenu
    id="account-menu"
    back-button-aria-label="Ga terug"
    close-button-aria-label="Sluiten"
    menu-type="accountMenu"
    (webMobileMenuNavigate)="onMobileMenuClick($event)"
></web-mobile-menu>
